import React, { useMemo, useState } from 'react';
import { getNavTheme } from '../../../../navigation/clinicNavConfig';
import WebBookingsIcon from './WebBookingsIcon';
import { WEB_BOOKINGS_PAGE_THEME } from './webBookingsTheme';

function WebBookingsNav({ tabs, activeTab, onTabChange, counts = {} }) {
    const [isOpen, setIsOpen] = useState(true);

    const activeLabel = useMemo(
        () => tabs.find((tab) => tab.id === activeTab)?.label || 'New Requests',
        [tabs, activeTab]
    );

    return (
        <div className={`ecx-page-card ecx-page-panel web-bookings-nav${isOpen ? '' : ' web-bookings-nav--collapsed'}`}>
            <div className="ecx-page-panel__header web-bookings-nav__header">
                <button
                    type="button"
                    className="web-bookings-nav__toggle d-lg-none"
                    onClick={() => setIsOpen((open) => !open)}
                    aria-expanded={isOpen}
                    aria-controls="web-bookings-nav-body"
                >
                    <div className="d-flex align-items-center gap-2 min-width-0">
                        <WebBookingsIcon icon="bi-calendar-check" theme={WEB_BOOKINGS_PAGE_THEME} size="sm" />
                        <div className="text-start min-width-0">
                            <h6 className="mb-0 fw-normal">Requests</h6>
                            {!isOpen && (
                                <span className="web-bookings-nav__active small text-muted text-truncate d-block">
                                    {activeLabel}
                                </span>
                            )}
                        </div>
                    </div>
                    <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'} web-bookings-nav__chevron`}></i>
                </button>

                <div className="d-none d-lg-flex align-items-center gap-2">
                    <WebBookingsIcon icon="bi-calendar-check" theme={WEB_BOOKINGS_PAGE_THEME} size="sm" />
                    <h6 className="mb-0 fw-normal">Sections</h6>
                </div>
            </div>

            <div id="web-bookings-nav-body" className="ecx-page-panel__body ecx-page-scroll web-bookings-nav__body">
                <div className="web-bookings-nav__list">
                    {tabs.map((tab) => {
                        const theme = getNavTheme(tab.theme);
                        const isActive = activeTab === tab.id;

                        return (
                            <button
                                key={tab.id}
                                type="button"
                                className={`web-bookings-nav__item ${
                                    isActive ? `${theme.activeClass} is-active` : theme.idleClass
                                }`}
                                onClick={() => onTabChange(tab.id)}
                            >
                                <WebBookingsIcon icon={tab.icon} theme={tab.theme} size="sm" className="web-bookings-nav__item-icon" />
                                <span className="web-bookings-nav__item-label">{tab.label}</span>
                                {counts[tab.id] != null && counts[tab.id] > 0 && (
                                    <span className="web-bookings-nav__item-count">{counts[tab.id]}</span>
                                )}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default WebBookingsNav;
